export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=702fb85fa8bb02a8cb8b21e4a14c596c1f4669b96a&name=pushAdClickData!'